export default function HeroSection() {
  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section
      id="hero"
      className="relative min-h-screen flex items-center overflow-hidden bg-background-50"
    >
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dark%20dramatic%20abstract%20composition%20with%20crimson%20red%20and%20deep%20charcoal%20gradients%2C%20fragmented%20geometric%20shapes%20suggesting%20broken%20glass%20and%20digital%20pixels%2C%20moody%20cinematic%20lighting%20with%20subtle%20glow%20effects%2C%20dark%20atmospheric%20texture%2C%20no%20people%2C%20minimalist%20yet%20intense%2C%20conceptual%20art%20style&width=1800&height=1200&seq=hero-bg-wanghong&orientation=landscape"
          alt="网红黑料背景"
          className="w-full h-full object-cover"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-background-50/80 via-background-50/50 to-background-50/95"></div>

      <div className="relative z-10 w-full px-4 md:px-6 pt-[72px]">
        <div className="max-w-[1400px] mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-primary-500/15 border border-primary-500/25 mb-6">
              <span className="w-2 h-2 rounded-full bg-primary-500 animate-pulse"></span>
              <span className="text-xs text-primary-400 font-medium whitespace-nowrap">实时更新 · 吃瓜第一站</span>
            </div>

            <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading text-foreground-950 leading-tight">
              网红黑料
              <span className="block text-primary-500 mt-1">抖音快手网红塌房翻车第一爆料平台</span>
            </h1>

            <p className="mt-6 text-base md:text-lg text-foreground-500 leading-relaxed max-w-2xl mx-auto lg:mx-0">
              每日追踪抖音网红黑料、快手网红黑料最新动态，深度挖掘大号扒皮内幕。
              从塌房实锤到翻车丑闻，从情感纠纷到法律追责——海量网红黑料合集实时更新，
              为你呈现最真实的网红生态。全网吃瓜群众聚集地，不错过任何一个大瓜。
            </p>

            <div className="mt-6 flex flex-wrap items-center gap-6 justify-center lg:justify-start">
              <div className="flex items-center gap-2">
                <span className="text-2xl font-heading text-accent-500">500+</span>
                <span className="text-xs text-foreground-500">网红追踪</span>
              </div>
              <div className="w-px h-8 bg-background-300 hidden sm:block"></div>
              <div className="flex items-center gap-2">
                <span className="text-2xl font-heading text-accent-500">7×24</span>
                <span className="text-xs text-foreground-500">实时更新</span>
              </div>
              <div className="w-px h-8 bg-background-300 hidden sm:block"></div>
              <div className="flex items-center gap-2">
                <span className="text-2xl font-heading text-accent-500">10w+</span>
                <span className="text-xs text-foreground-500">吃瓜群众</span>
              </div>
            </div>

            <div className="mt-8 flex flex-col sm:flex-row gap-3 justify-center lg:justify-start">
              <a
                href="#topics"
                onClick={(e) => handleNavClick(e, '#topics')}
                className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-medium rounded-lg transition-all duration-200 whitespace-nowrap cursor-pointer text-sm"
              >
                立即吃瓜
                <i className="ri-arrow-right-line"></i>
              </a>
              <a
                href="#index"
                onClick={(e) => handleNavClick(e, '#index')}
                className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-background-200 hover:bg-background-300 text-foreground-700 font-medium rounded-lg transition-all duration-200 whitespace-nowrap cursor-pointer text-sm"
              >
                浏览专题
                <i className="ri-grid-line"></i>
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-lg lg:max-w-none">
            <div className="relative rounded-2xl overflow-hidden border border-background-200/60">
              <img
                src="https://readdy.ai/api/search-image?query=Dark%20cinematic%20abstract%20art%2C%20fragmented%20digital%20masks%20and%20shattered%20mirrors%2C%20crimson%20red%20accents%20on%20deep%20charcoal%20background%2C%20mysterious%20atmospheric%20glow%2C%20conceptual%20representation%20of%20hidden%20truths%20and%20revealed%20secrets%2C%20dramatic%20lighting%2C%20brooding%20mood%2C%20fine%20art%20photography%20style%2C%20no%20text%2C%20no%20people&width=800&height=900&seq=hero-visual-wanghong&orientation=portrait"
                alt="网红黑料 - 大号扒皮内幕爆料"
                className="w-full h-auto object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-background-50/30 to-transparent"></div>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 animate-bounce">
        <a
          href="#topics"
          onClick={(e) => handleNavClick(e, '#topics')}
          className="w-10 h-10 flex items-center justify-center rounded-full bg-background-200/60 hover:bg-background-300/60 text-foreground-500 transition-colors cursor-pointer"
        >
          <i className="ri-arrow-down-line"></i>
        </a>
      </div>
    </section>
  );
}